import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WatercraftContext } from 'wmic-pe-capability-gateway-quoteandbind-ho-react';
import metadata from './WMICHOBoatInfoDetails.metadata.json5';
import messages from './WMICHOBoatInfoDetails.messages.js';

function WMICHOBoatInfoDetails({ 
    id,
    boatData,
    onValidate,
    showErrors,
    boatTypeReadOnly,
    readOnly,
}) {
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const { updateWatercraftRiskView } = useContext(WatercraftContext);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }

        // if component is unmounted, report as valid so it doesn't break the rest of the form
        return () => {
            if (onValidate) {
                onValidate(true, id);
            }
        }
    }, [id, onValidate, isComponentValid])

    const overrideProps = {
        '@field': {
            readOnly,
            parentNode: boatData,
        },
        boatInfoBoatTypeSelect: {
            readOnly: readOnly || boatTypeReadOnly,
        },
    };


    return (
        <ViewModelForm
            model={boatData}
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onModelChange={updateWatercraftRiskView}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
};

WMICHOBoatInfoDetails.propTypes = {
    boatData: PropTypes.shape({}).isRequired,
    boatTypeReadOnly: PropTypes.bool,
    readOnly: PropTypes.bool,
};

WMICHOBoatInfoDetails.defaultProps = {
    boatTypeReadOnly: false,
    readOnly: false
};

export default WMICHOBoatInfoDetails;
